import { z } from 'zod';
import { record } from 'fp-ts';
import { TextKey } from '@mews-commander/enums';

const roleSchemaFactory = ({
    nameErrorTextKey,
    privilegesErrorTextKey,
}: {
    nameErrorTextKey: Mews.TextKey;
    privilegesErrorTextKey: Mews.TextKey;
}) =>
    z.object({
        name: z.string().trim().min(1, { message: nameErrorTextKey }),
        privileges: z.record(z.string(), z.boolean()).refine((obj) => !record.isEmpty(obj), {
            message: privilegesErrorTextKey,
        }),
    });

export const editRoleSchema = roleSchemaFactory({
    nameErrorTextKey: TextKey.RoleEditErrorRoleName,
    privilegesErrorTextKey: TextKey.RoleEditErrorPermissions,
});

export type EditRoleFormValues = z.infer<typeof editRoleSchema>;

export const createRoleSchema = roleSchemaFactory({
    nameErrorTextKey: TextKey.RoleCreateErrorRoleName,
    privilegesErrorTextKey: TextKey.RoleCreateErrorPermissions,
});

export type CreateRoleFormValues = z.infer<typeof createRoleSchema>;
